const Animation = {
  baseStyle: () => ({
    borderRadius: 30,
  }),
};

export default Animation;
